module.exports = __webpack_public_path__ + "static/media/goodday_update.ec659793.png";